import { DragEvent, useRef } from "react";
import cn from "classnames";
import { useToggleState } from "../../../../packages/hooks";
import { DropzoneOverlay } from "./dropzone-overlay";
import styles from "./dropzone.module.scss";

interface Props {
  children: React.ReactNode;
}

export const Dropzone = ({ children }: Props) => {
  const {
    toggle: isDragging,
    toggleOn: setIsDragging,
    toggleOff: resetIsDragging,
  } = useToggleState();

  const dragCounter = useRef(0);

  const preventDefaults = (event: DragEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrag = (event: DragEvent) => {
    preventDefaults(event);
    dragCounter.current += 1;

    if (dragCounter.current === 1) {
      setIsDragging();
    }
  };

  const handleDragLeave = (event: DragEvent) => {
    preventDefaults(event);
    dragCounter.current -= 1;

    if (dragCounter.current === 0) {
      resetIsDragging();
    }
  };

  const dropzoneStyles = cn(styles.dropzone, {
    [styles.dragging]: isDragging,
  });

  return (
    <div
      id="chat-dropzone"
      className={dropzoneStyles}
      onDragEnter={handleDrag}
      onDragLeave={handleDragLeave}
      onDragOver={preventDefaults}
      onDrop={handleDragLeave}
    >
      <DropzoneOverlay isDragging={isDragging} />
      {children}
    </div>
  );
};
